<template>
  <div class="p-invitation__out">
    <section
      ref="container"
      class="p-invitation"
    >
      <h1 class="p-invitation__title">
        Пригласить друга
      </h1>
      <p class="p-invitation__txt a-font__l">
        Выбери один из вариантов для приглашения:
      </p>
      <div class="p-invitation__btn-group m_gap16">
        <BaseButton
          class="m_w311 mm_w100p m_font-big"
          @click="invitePage"
        >
          Онлайн-анкета
        </BaseButton>
        <BaseButton
          class="m_w311 mm_w100p m_font-big plc_ref-link"
          variant="contrast"
          @click="copyLink"
        >
          Моя реферальная ссылка
        </BaseButton>
      </div>
    </section>
    <div class="p-invitation__decoration"></div>
  </div>
</template>

<script lang="ts">
import './p_invitation.scss';
import AppPopupInvitation from '@/shared/components/AppPopupInvitation/AppPopupInvitation.vue';
import { defineComponent } from 'vue';
import BaseButton from '@/shared/lib/uikit/components/BaseButton/BaseButton.vue';

export default defineComponent({
  name: 'PInvitation',
  components: { BaseButton },
  extends: AppPopupInvitation,
});
</script>
